import { put, takeLatest, call } from "redux-saga/effects";
import Api from "./api";
import {
  BULK_UPDATE_EMPLOYEES_ACTION,
  BULK_UPDATE_EMPLOYEES_LOADING,
  BULK_UPDATE_EMPLOYEES_SUCCESS,
  BULK_UPDATE_EMPLOYEES_ERROR,
  ONBOARD_EMPLOYEES_ACTION,
  ONBOARD_EMPLOYEES_LOADING,
  ONBOARD_EMPLOYEES_SUCCESS,
  ONBOARD_EMPLOYEES_ERROR,
  ONBOARD_EMPLOYEES_VERIFY_ACTION,
  ONBOARD_EMPLOYEES_VERIFY_LOADING,
  ONBOARD_EMPLOYEES_VERIFY_SUCCESS,
  ONBOARD_EMPLOYEES_VERIFY_ERROR,
  INVITE_EMPLOYEES_ACTION,
  INVITE_EMPLOYEES_LOADING,
  INVITE_EMPLOYEES_SUCCESS,
  INVITE_EMPLOYEES_ERROR,
  UPDATE_EMPLOYEE_ACTION,
  UPDATE_EMPLOYEE_LOADING,
  UPDATE_EMPLOYEE_SUCCESS,
  UPDATE_EMPLOYEE_ERROR,
  OVERTIME_LIST_ACTION,
  OVERTIME_LIST_LOADING,
  OVERTIME_LIST_SUCCESS,
  OVERTIME_LIST_ERROR,
  GET_OVERTIME_ACTION,
  GET_OVERTIME_LOADING,
  GET_OVERTIME_SUCCESS,
  GET_OVERTIME_ERROR,
  APPROVE_OVERTIME_ACTION,
  APPROVE_OVERTIME_LOADING,
  APPROVE_OVERTIME_SUCCESS,
  APPROVE_OVERTIME_ERROR,
  REJECT_OVERTIME_ACTION,
  REJECT_OVERTIME_LOADING,
  REJECT_OVERTIME_SUCCESS,
  REJECT_OVERTIME_ERROR,
  LEAVE_LIST_ACTION,
  LEAVE_LIST_LOADING,
  LEAVE_LIST_SUCCESS,
  LEAVE_LIST_ERROR,
  CREATE_LEAVE_ACTION,
  CREATE_LEAVE_LOADING,
  CREATE_LEAVE_SUCCESS,
  CREATE_LEAVE_ERROR,
  CREATE_PAYSTACK_PROFILE_LOADING,
  CREATE_PAYSTACK_PROFILE_ERROR,
  CREATE_PAYSTACK_PROFILE_SUCCESS,
  CREATE_PAYSTACK_PROFILE_ACTION,
  GET_COMPANY_PAYMENT_ACTION,
  GET_COMPANY_PAYMENT_ERROR,
  GET_COMPANY_PAYMENT_SUCCESS,
  GET_COMPANY_PAYMENT_LOADING,
  GET_WITHDRAWAL_CATEGORIES_ACTION,
  GET_WITHDRAWAL_CATEGORIES_ERROR,
  GET_WITHDRAWAL_CATEGORIES_LOADING,
  GET_WITHDRAWAL_CATEGORIES_SUCCESS,
  INVITE_PENDING_EMPLOYEES_ACTION,
  INVITE_PENDING_EMPLOYEES_LOADING,
  INVITE_PENDING_EMPLOYEES_SUCCESS,
  INVITE_PENDING_EMPLOYEES_ERROR,
  LIST_EMPLOYEE_COMPANY_JOIN_REQUEST_ACTION,
  LIST_EMPLOYEE_COMPANY_JOIN_REQUEST_SUCCESS,
  LIST_EMPLOYEE_COMPANY_JOIN_REQUEST_ERROR,
  LIST_EMPLOYEE_COMPANY_JOIN_REQUEST_LOADING,
  UPDATE_EMPLOYEE_COMPANY_JOIN_REQUEST_ACTION,
  UPDATE_EMPLOYEE_COMPANY_JOIN_REQUEST_SUCCESS,
  UPDATE_EMPLOYEE_COMPANY_JOIN_REQUEST_ERROR,
  UPDATE_EMPLOYEE_COMPANY_JOIN_REQUEST_LOADING,
  EMPLOYEE_COMPANY_JOIN_REQUEST_APPROVE_ACTION,
  EMPLOYEE_COMPANY_JOIN_REQUEST_APPROVE_LOADING,
  EMPLOYEE_COMPANY_JOIN_REQUEST_APPROVE_ERROR,
  EMPLOYEE_COMPANY_JOIN_REQUEST_APPROVE_SUCCESS,
  EMPLOYEE_COMPANY_JOIN_REQUEST_REJECT_ACTION,
  EMPLOYEE_COMPANY_JOIN_REQUEST_REJECT_LOADING,
  EMPLOYEE_COMPANY_JOIN_REQUEST_REJECT_SUCCESS,
  EMPLOYEE_COMPANY_JOIN_REQUEST_REJECT_ERROR,
  LIST_EMPLOYEE_COMPANY_JOIN_REQUEST_AUDIT_LOGS_ACTION,
  LIST_EMPLOYEE_COMPANY_JOIN_REQUEST_AUDIT_LOGS_LOADING,
  LIST_EMPLOYEE_COMPANY_JOIN_REQUEST_AUDIT_LOGS_SUCCESS,
  LIST_EMPLOYEE_COMPANY_JOIN_REQUEST_AUDIT_LOGS_ERROR,
  INVITE_COMPANY_ADMIN_ACTION,
  INVITE_COMPANY_ADMIN_LOADING,
  INVITE_COMPANY_ADMIN_SUCCESS,
  INVITE_COMPANY_ADMIN_ERROR,
  CHANGE_EMPLOYEE_PERMISSION_ACTION,
  CHANGE_EMPLOYEE_PERMISSION_LOADING,
  CHANGE_EMPLOYEE_PERMISSION_SUCCESS,
  CHANGE_EMPLOYEE_PERMISSION_ERROR,
} from "./types";

function* bulkUpdateEmployeesSaga(data) {
  yield put({ type: BULK_UPDATE_EMPLOYEES_LOADING });
  try {
    let res = yield call(Api.bulkUpdateEmployees, data.payload);
    if (res.message) {
      yield put({ type: BULK_UPDATE_EMPLOYEES_ERROR, payload: res.message });
    } else if (res.errors && res.errors.length) {
      yield put({ type: BULK_UPDATE_EMPLOYEES_SUCCESS, payload: res });
    } else {
      yield put({ type: BULK_UPDATE_EMPLOYEES_SUCCESS, payload: res });
    }
  } catch (error) {
    yield put({ type: BULK_UPDATE_EMPLOYEES_ERROR, payload: error.message });
  }
}

function* onBoardEmployeesSaga(data) {
  yield put({ type: ONBOARD_EMPLOYEES_LOADING });
  try {
    let res = yield call(Api.onBoardEmployees, data.payload);
    if (res.message) {
      yield put({ type: ONBOARD_EMPLOYEES_ERROR, payload: res.message });
    } else yield put({ type: ONBOARD_EMPLOYEES_SUCCESS, payload: res });
  } catch (error) {
    yield put({ type: ONBOARD_EMPLOYEES_ERROR, payload: error.message });
  }
}

function* onBoardEmployeesVerifySaga(data) {
  yield put({ type: ONBOARD_EMPLOYEES_VERIFY_LOADING });
  try {
    let res = yield call(Api.onBoardEmployeesVerify, data.payload);
    if (res.message) {
      yield put({ type: ONBOARD_EMPLOYEES_VERIFY_ERROR, payload: Array.isArray(res?.details) ? res?.details : res?.message });
    } else yield put({ type: ONBOARD_EMPLOYEES_VERIFY_SUCCESS, payload: res });
  } catch (error) {
    yield put({ type: ONBOARD_EMPLOYEES_VERIFY_ERROR, payload: error.message });
  }
}

function* inviteEmployeesSaga(data) {
  yield put({ type: INVITE_EMPLOYEES_LOADING });
  try {
    let res = yield call(Api.inviteEmployees, data.payload);
    if (res.message) {
      yield put({ type: INVITE_EMPLOYEES_ERROR, payload: res.message });
    } else yield put({ type: INVITE_EMPLOYEES_SUCCESS, payload: res });
  } catch (error) {
    yield put({ type: INVITE_EMPLOYEES_ERROR, payload: error.message });
  }
}

function* invitePendingEmployeesSaga(data) {
  yield put({ type: INVITE_PENDING_EMPLOYEES_LOADING });
  try {
    let res = yield call(Api.invitePendingEmployees, data.payload);
    if (res.message) {
      yield put({ type: INVITE_PENDING_EMPLOYEES_ERROR, payload: res.message });
    } else yield put({ type: INVITE_PENDING_EMPLOYEES_SUCCESS, payload: res });
  } catch (error) {
    yield put({ type: INVITE_PENDING_EMPLOYEES_ERROR, payload: error.message });
  }
}


function* updateEmployeeSaga(data) {
  yield put({ type: UPDATE_EMPLOYEE_LOADING });
  try {
    let res = yield call(Api.updateEmployee, data.payload, data.employee_id);
    if (res.message) {
      yield put({ type: UPDATE_EMPLOYEE_ERROR, payload: res.message });
    } else yield put({ type: UPDATE_EMPLOYEE_SUCCESS, payload: res });
  } catch (error) {
    yield put({ type: UPDATE_EMPLOYEE_ERROR, payload: error.message });
  }
}

function* createPayStackProfileSaga(data) {
  yield put({ type: CREATE_PAYSTACK_PROFILE_LOADING });
  try {
    let res = yield call(Api.createPayStackProfile, data.payload.employee_id, { company_id: data.payload.company_id });
    if (res.message) {
      console.error(res)
      yield put({ type: CREATE_PAYSTACK_PROFILE_ERROR, payload: [res.details?.data] || res.message });
    } else yield put({ type: CREATE_PAYSTACK_PROFILE_SUCCESS, payload: res });
  } catch (error) {
    yield put({ type: CREATE_PAYSTACK_PROFILE_ERROR, payload: error.message });
  }
}

function* getOvertimeListSaga(data) {
  yield put({ type: OVERTIME_LIST_LOADING });
  try {
    let res = yield call(Api.getOvertimeList, data.payload);
    if (res.message) {
      yield put({ type: OVERTIME_LIST_ERROR, payload: res.message });
    } else yield put({ type: OVERTIME_LIST_SUCCESS, payload: res });
  } catch (error) {
    yield put({ type: OVERTIME_LIST_ERROR, payload: error.message });
  }
}

function* getOvertimeInfoSaga(data) {
  yield put({ type: GET_OVERTIME_LOADING });
  try {
    let res = yield call(Api.getOvertimeInfo, data.overtime_id);
    if (res.message) {
      yield put({ type: GET_OVERTIME_ERROR, payload: res.message });
    } else yield put({ type: GET_OVERTIME_SUCCESS, payload: res });
  } catch (error) {
    yield put({ type: GET_OVERTIME_ERROR, payload: error.message });
  }
}

function* approveOvertimeSaga(data) {
  yield put({ type: APPROVE_OVERTIME_LOADING });
  try {
    let res = yield call(Api.approveOvertime, data.overtime_id, data.payload);
    if (res.message) {
      yield put({ type: APPROVE_OVERTIME_ERROR, payload: res.message });
    } else yield put({ type: APPROVE_OVERTIME_SUCCESS, payload: res });
  } catch (error) {
    yield put({ type: APPROVE_OVERTIME_ERROR, payload: error.message });
  }
}

function* rejectOvertimeSaga(data) {
  yield put({ type: REJECT_OVERTIME_LOADING });
  try {
    let res = yield call(Api.rejectOvertime, data.overtime_id, data.payload);
    if (res.message) {
      yield put({ type: REJECT_OVERTIME_ERROR, payload: res.message });
    } else yield put({ type: REJECT_OVERTIME_SUCCESS, payload: res });
  } catch (error) {
    yield put({ type: REJECT_OVERTIME_ERROR, payload: error.message });
  }
}

function* getLeaveListSaga(data) {
  yield put({ type: LEAVE_LIST_LOADING });
  try {
    let res = yield call(Api.getLeaveList, data.payload);
    if (res.message) {
      yield put({ type: LEAVE_LIST_ERROR, payload: res.message });
    } else yield put({ type: LEAVE_LIST_SUCCESS, payload: res });
  } catch (error) {
    yield put({ type: LEAVE_LIST_ERROR, payload: error.message });
  }
}

function* createLeaveSaga(data) {
  yield put({ type: CREATE_LEAVE_LOADING });
  try {
    let res = yield call(Api.createLeave, data.payload);
    if (res.message) {
      yield put({ type: CREATE_LEAVE_ERROR, payload: res.message });
    } else yield put({ type: CREATE_LEAVE_SUCCESS, payload: res });
  } catch (error) {
    yield put({ type: CREATE_LEAVE_ERROR, payload: error.message });
  }
}

function* getCompanyPaymentsList(data) {
  yield put({ type: GET_COMPANY_PAYMENT_LOADING });
  try {
    let res = yield call(Api.getCompanyPayments, data.payload);
    if (res.message) {
      yield put({ type: GET_COMPANY_PAYMENT_ERROR, payload: res.message });
    } else yield put({ type: GET_COMPANY_PAYMENT_SUCCESS, payload: res });
  } catch (error) {
    yield put({ type: GET_COMPANY_PAYMENT_ERROR, payload: error.message })
  }
}

function* getWithdrawalLimitCategoriesSaga(action) {
  yield put({ type: GET_WITHDRAWAL_CATEGORIES_LOADING });
  try {
    let res = yield call(Api.getWithdrawalLimitCategories, action.payload);
    if (res.message) {
      yield put({ type: GET_WITHDRAWAL_CATEGORIES_ERROR, payload: res.message })
    } else yield put({ type: GET_WITHDRAWAL_CATEGORIES_SUCCESS, payload: res })
  } catch (error) {
    yield put({ type: GET_WITHDRAWAL_CATEGORIES_ERROR, payload: error.message })
  }
}

function* listEmployeeCompanyJoinRequestsSaga(action) {
  yield put({ type: LIST_EMPLOYEE_COMPANY_JOIN_REQUEST_LOADING });
  try {
    let res = yield call(Api.listEmployeeCompanyJoinRequests, action.payload);
    if (res.message) {
      yield put({ type: LIST_EMPLOYEE_COMPANY_JOIN_REQUEST_ERROR, payload: res.message })
    } else yield put({ type: LIST_EMPLOYEE_COMPANY_JOIN_REQUEST_SUCCESS, payload: res })
  } catch (error) {
    yield put({ type: LIST_EMPLOYEE_COMPANY_JOIN_REQUEST_ERROR, payload: error.message })
  }
}

function* updateEmployeeCompanyJoinRequestSaga(action) {
  yield put({ type: UPDATE_EMPLOYEE_COMPANY_JOIN_REQUEST_LOADING });
  try {
    let res = yield call(Api.updateEmployeeCompanyJoinRequest, action.payload, action.request_id);
    if (res.message) {
      yield put({ type: UPDATE_EMPLOYEE_COMPANY_JOIN_REQUEST_ERROR, payload: res.message })
    } else yield put({
      type: UPDATE_EMPLOYEE_COMPANY_JOIN_REQUEST_SUCCESS,
      payload: res?.data,
      employee_company_join_request_id: action.request_id
    })
  } catch (error) {
    yield put({ type: UPDATE_EMPLOYEE_COMPANY_JOIN_REQUEST_ERROR, payload: error.message })
  }
}

function* employeeCompanyJoinRequestApproveSaga(action) {
  yield put({ type: EMPLOYEE_COMPANY_JOIN_REQUEST_APPROVE_LOADING });
  try {
    let res = yield call(Api.employeeCompanyJoinRequestApprove, action.request_id);
    if (res.message) {
      yield put({ type: EMPLOYEE_COMPANY_JOIN_REQUEST_APPROVE_ERROR, payload: res.message });
    } else yield put({ type: EMPLOYEE_COMPANY_JOIN_REQUEST_APPROVE_SUCCESS, payload: res });
  } catch (error) {
    yield put({ type: EMPLOYEE_COMPANY_JOIN_REQUEST_APPROVE_ERROR, payload: error.message });
  }
}

function* employeeCompanyJoinRequestRejectSaga(action) {
  yield put({ type: EMPLOYEE_COMPANY_JOIN_REQUEST_REJECT_LOADING });

  try {
    let res = yield call(Api.employeeCompanyJoinRequestReject, action.request_id, action.payload);
    if (res.message) {
      yield put({ type: EMPLOYEE_COMPANY_JOIN_REQUEST_REJECT_ERROR, payload: res.message });
    } else yield put({ type: EMPLOYEE_COMPANY_JOIN_REQUEST_REJECT_SUCCESS, payload: res });

  } catch (error) {
    yield put({ type: EMPLOYEE_COMPANY_JOIN_REQUEST_REJECT_ERROR, payload: error.message });
  }
}

function* changeEmployeePermissionSaga(action) {
  yield put({ type: CHANGE_EMPLOYEE_PERMISSION_LOADING });
  try {
    const res = yield call(Api.changeEmployeePermission, action.user_id, action.payload);
    if (res?.message) {
      yield put({ type: CHANGE_EMPLOYEE_PERMISSION_ERROR, payload: res.message });
    } else {
      // Success payload is the updated user object — components use it to
      // reconcile is_admin/is_hr immediately without a follow-up fetch.
      yield put({ type: CHANGE_EMPLOYEE_PERMISSION_SUCCESS, payload: res?.data || res });
    }
  } catch (error) {
    yield put({ type: CHANGE_EMPLOYEE_PERMISSION_ERROR, payload: error.message });
  }
}

function* listEmployeeCompanyJoinRequestAuditLogsSaga(action) {
  yield put({
    type: LIST_EMPLOYEE_COMPANY_JOIN_REQUEST_AUDIT_LOGS_LOADING,
    request_id: action.request_id,
  });
  try {
    let res = yield call(Api.employeeCompanyJoinRequestAuditLogs, action.request_id, action.payload);
    if (res.message) {
      yield put({
        type: LIST_EMPLOYEE_COMPANY_JOIN_REQUEST_AUDIT_LOGS_ERROR,
        payload: res.message,
      });
    } else {
      yield put({
        type: LIST_EMPLOYEE_COMPANY_JOIN_REQUEST_AUDIT_LOGS_SUCCESS,
        request_id: action.request_id,
        payload: res,
      });
    }
  } catch (error) {
    yield put({
      type: LIST_EMPLOYEE_COMPANY_JOIN_REQUEST_AUDIT_LOGS_ERROR,
      payload: error.message,
    });
  }
}

function* inviteCompanyAdminSaga(action) {
  yield put({ type: INVITE_COMPANY_ADMIN_LOADING });
  try {
    let res = yield call(Api.inviteCompanyAdmin, action.payload);
    if (res.message) {
      yield put({ type: INVITE_COMPANY_ADMIN_ERROR, payload: res.message });
    } else {
      yield put({ type: INVITE_COMPANY_ADMIN_SUCCESS, payload: res });
    }
  } catch (error) {
    yield put({ type: INVITE_COMPANY_ADMIN_ERROR, payload: error.message });
  }
}

function* watchCompanyDashboardAsync() {
  yield takeLatest(BULK_UPDATE_EMPLOYEES_ACTION, bulkUpdateEmployeesSaga);
  yield takeLatest(ONBOARD_EMPLOYEES_ACTION, onBoardEmployeesSaga);
  yield takeLatest(ONBOARD_EMPLOYEES_VERIFY_ACTION, onBoardEmployeesVerifySaga);
  yield takeLatest(INVITE_EMPLOYEES_ACTION, inviteEmployeesSaga);
  yield takeLatest(INVITE_PENDING_EMPLOYEES_ACTION, invitePendingEmployeesSaga);
  yield takeLatest(UPDATE_EMPLOYEE_ACTION, updateEmployeeSaga);
  yield takeLatest(CREATE_PAYSTACK_PROFILE_ACTION, createPayStackProfileSaga);
  yield takeLatest(OVERTIME_LIST_ACTION, getOvertimeListSaga);
  yield takeLatest(GET_OVERTIME_ACTION, getOvertimeInfoSaga);
  yield takeLatest(APPROVE_OVERTIME_ACTION, approveOvertimeSaga);
  yield takeLatest(REJECT_OVERTIME_ACTION, rejectOvertimeSaga);
  yield takeLatest(LEAVE_LIST_ACTION, getLeaveListSaga);
  yield takeLatest(CREATE_LEAVE_ACTION, createLeaveSaga);
  yield takeLatest(GET_COMPANY_PAYMENT_ACTION, getCompanyPaymentsList);
  yield takeLatest(GET_WITHDRAWAL_CATEGORIES_ACTION, getWithdrawalLimitCategoriesSaga);
  yield takeLatest(LIST_EMPLOYEE_COMPANY_JOIN_REQUEST_ACTION, listEmployeeCompanyJoinRequestsSaga);
  yield takeLatest(UPDATE_EMPLOYEE_COMPANY_JOIN_REQUEST_ACTION, updateEmployeeCompanyJoinRequestSaga);
  yield takeLatest(EMPLOYEE_COMPANY_JOIN_REQUEST_APPROVE_ACTION, employeeCompanyJoinRequestApproveSaga);
  yield takeLatest(EMPLOYEE_COMPANY_JOIN_REQUEST_REJECT_ACTION, employeeCompanyJoinRequestRejectSaga);
  yield takeLatest(LIST_EMPLOYEE_COMPANY_JOIN_REQUEST_AUDIT_LOGS_ACTION, listEmployeeCompanyJoinRequestAuditLogsSaga);
  yield takeLatest(INVITE_COMPANY_ADMIN_ACTION, inviteCompanyAdminSaga);
  yield takeLatest(CHANGE_EMPLOYEE_PERMISSION_ACTION, changeEmployeePermissionSaga);
}

export default watchCompanyDashboardAsync;
